module.exports = __webpack_public_path__ + "img/TECNOLOGIA-SWIFT-SPORT-5.62f91d91.jpg";